import React, { useState, useEffect,useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, NavLink } from 'react-router-dom';
import { LoadingProvider, useLoading } from './components/LoadingContext'; 
import Loader from './components/Loader'; 
import axios from './axiosConfig';
import { BsExclamationCircleFill } from 'react-icons/bs'; // Ícono de advertencia


import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

// Importa los componentes de las páginas
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ShowDatos from './pages/Participantes/ShowDatos';
import CreateDatos from './pages/Participantes/CreateDatos';
import EditDatos from './pages/Participantes/EditDatos';
import ShowMoreDatos from './pages/Participantes/ShowMoreDatos';
import InscripcionCursos from './pages/Cursos/InscripcionCursos';
import InscribirCedula from './pages/Cursos/InscribirCedula';
import ShowInscritos from './pages/Cursos/ShowInscritos';
import ShowCursos from './pages/Cursos/ShowCursos';
import CreateCursos from './pages/Cursos/CreateCursos';
import EditCursos from './pages/Cursos/EditCursos';
import ShowPagos from './pages/Participantes/ReportePagos/ShowPagos';
import CreatePagos from './pages/Participantes/ReportePagos/CreatePagos';
import CreatePagosCedula from './pages/Participantes/ReportePagos/CreatePagosCedula';
import ShowMorePagos from './pages/Participantes/ReportePagos/ShowMorePagos';
import ShowVoluntariados from './pages/Participantes/Voluntariados/ShowVoluntariados';
import ShowMoreVoluntariados from './pages/Participantes/Voluntariados/ShowMoreVoluntariados';
import CreateVoluntariados from './pages/Participantes/Voluntariados/CreateVoluntariados';
import EditVoluntariados from './pages/Participantes/Voluntariados/EditVoluntariados';
import ShowPromocion from './pages/Promocion/ShowPromocion';
import ShowMorePromocion from './pages/Promocion/ShowMorePromocion';
import CreatePromocion from './pages/Promocion/CreatePromocion';
import EditPromocion from './pages/Promocion/EditPromocion';
import ProtectedRoute from './components/ProtectedRoute';
import { puedeVerModulo } from './components/accesoModulos';
import ShowUsers from './pages/Users/ShowUsers';
import EditUsers from './pages/Users/EditUsers';
import ShowPeticiones from './pages/Bandeja/ShowPeticiones';
import ShowPeticionesNoAtentidas from './pages/Bandeja/ShowPeticionesNoAtentidas';
import ShowPagosCursos from './pages/Participantes/ReportePagos/ShowPagosCursos';
import Dashboard from './Dashboard';
import { useLocation } from 'react-router-dom'; // Importa useLocation
import CreateUsers from './pages/Users/CreateUsers';
import CreatePagoCursos from './pages/Cursos/CreatePagoCursos';
import ShowMoreCursos from './pages/Cursos/ShowMoreCursos';
import ShowPatrocinantes from './pages/Patrocinantes/ShowPatrocinantes';
import CreatePatrocinantes from './pages/Patrocinantes/CreatePatrocinantes';
import EditPatrocinantes from './pages/Patrocinantes/EditPatrocinantes';
import ShowMorePatrocinantes from './pages/Patrocinantes/ShowMorePatrocinantes';
import ShowDatosCursos from './pages/Participantes/ShowDatosCursos';
import ShowMoreInscripciones from './pages/Cursos/ShowMoreInscripciones';
import EditInscripciones from './pages/Cursos/EditInscripciones';
import ShowProcedencias from './pages/Procedencias/ShowProcedencias';
import CreateProcedencias from './pages/Procedencias/CreateProcedencias';
import EditProcedencias from './pages/Procedencias/EditProcedencias';
import ShowPagosProgramas from './pages/Participantes/ReportePagos/ShowPagosProgramas';
import CambiarClave from './pages/Users/CambiarClave';
import ShowIndicadores from './pages/CalculoIndicadores/ShowIndicadores';
import ShowIndicadoresIniciativas from './pages/CalculoIndicadores/ShowIndicadoresIniciativas';
import ShowRedEgresados from './pages/CalculoIndicadores/ShowRedEgresados';
import ShowSeguimientoEgresados from './pages/SeguimientoEgresados/ShowSeguimientoEgresados';
import SeguimientoEgresado from './pages/SeguimientoEgresados/SeguimientoEgresado';
import ConfirmInscripciones from './pages/Cursos/ConfirmInscripciones';
import ShowCursosExternos from './pages/Cursos/ShowCursosExternos';
import CreateCursosExterno from './pages/Cursos/CreateCursosExterno';
import InscribirExterno from './pages/Cursos/InscribirExterno';
import ShowBolsaEmpleo from './pages/BolsaEmpleo/ShowBolsaEmpleo';
import IncsParticipanteBolsa from './pages/BolsaEmpleo/IncsParticipanteBolsa';
import IncsEmpleo from './pages/BolsaEmpleo/IncsEmpleo';
import ShowPostulados from './pages/BolsaEmpleo/ShowPostulados';
import ShowMorePostulados from './pages/BolsaEmpleo/ShowMorePostulados';
import ShowPostulaciones from './pages/BolsaEmpleo/ShowPostulaciones';
import ShowPostulacionesEmpresas from './pages/BolsaEmpleo/ShowPostulacionesEmpresa';
import EditIncsParticipanteBolsa from './pages/BolsaEmpleo/EditIncsParticipanteBolsa.js';
import { Modal, Button } from 'react-bootstrap';
import InscribirMasivoInterno from './pages/Cursos/InscribirMasivoInterno.js';
import Config2fa from './pages/Users/Config2fa.js';
import ShowCentros from './pages/Centro/ShowCentros.js';
import CreateCentros from './pages/Centro/CreateCentros.js';
import EditCentros from './pages/Centro/EditCentros.js';
import ShowCohorte from './pages/Cohorte/ShowCohorte.js';
import CreateCohorte from './pages/Cohorte/CreateCohorte.js';
import EditCohorte from './pages/Cohorte/EditCohorte.js';
import ShowCostoCurso from './pages/Cursos/CostoCursos/ShowCostoCurso.js';
import CreateCostoCurso from './pages/Cursos/CostoCursos/CreateCostoCurso.js';
import EditCostoCurso from './pages/Cursos/CostoCursos/EditCostoCurso.js';
import ShowInscritosExternos from './pages/Cursos/ShowInscritosExternos.js';
import ConfirmDatos from './pages/Participantes/ConfirmDatos.js';
import ConfirmCentro from './pages/Centro/ConfirmCentro.js';
import ShowCursosAliados from './pages/Cursos/ShowCursosAliados.js';
import InscribirMasivoAliados from './pages/Cursos/InscribirMasivoAliados.js';
import ShowInscritosAliados from './pages/Cursos/ShowInscritosAliados.js';
import ConfirmCursos from './pages/Cursos/ConfirmCursos.js';
import ConfirmPartEInsc from './pages/Cursos/ConfirmPartEInsc.js';
import ConfirmProcedencia from './pages/Procedencias/ConfirmProcedencia.js';
import ShowIniciativas from './pages/Iniciativas/ShowIniciativas.js';
import CreateIniciativas from './pages/Iniciativas/CreateIniciativas.js';
import EditIniciativas from './pages/Iniciativas/EditIniciativas.js';
import ShowInscIniciativas from './pages/InscIniciativas/ShowInscIniciativas.js';
import ShowInscritosIniciativas from './pages/InscIniciativas/ShowInscritosIniciativas.js';
import ShowPartIniciativas from './pages/ParticipanteIniciativa/ShowPartIniciativas.js';
import CreatePartIniciativa from './pages/ParticipanteIniciativa/CreatePartIniciativa.js';
import ShowMorePartIniciativa from './pages/ParticipanteIniciativa/ShowMorePartIniciativa.js';
import EditPartIniciativa from './pages/ParticipanteIniciativa/EditPartIniciativa.js';
import EditInscIniciativas from './pages/InscIniciativas/EditInscIniciativas.js';
import InscribirIniciativas from './pages/InscIniciativas/InscribirIniciativas.js';
import ConfirmCostoCurso from './pages/Cursos/CostoCursos/ConfirmCostoCurso.js';
import ConfirmVoluntariados from './pages/Participantes/Voluntariados/ConfirmVoluntariados.js';


function App() {
  return (
    <LoadingProvider>
      
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* Envuelve todas las rutas protegidas con AuthenticatedLayout y ProtectedRoute */}
            <Route path="/peticiones" element={<AuthenticatedLayout><ShowPeticiones /></AuthenticatedLayout>} />
            <Route path="/dashboard" element={<AuthenticatedLayout><Dashboard /></AuthenticatedLayout>} />
            <Route path="/peticiones/Noat" element={<AuthenticatedLayout><ShowPeticionesNoAtentidas /></AuthenticatedLayout>} />
            <Route path="users" element={<AuthenticatedLayout><ShowUsers /></AuthenticatedLayout>} />
            <Route path="users/:id" element={<ProtectedRoute allowedRoles={['admin']}><AuthenticatedLayout><EditUsers /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="users/create" element={<ProtectedRoute allowedRoles={['admin']}><AuthenticatedLayout><CreateUsers /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="f2a/config" element={<AuthenticatedLayout><Config2fa /></AuthenticatedLayout>} />
            <Route path="cambiar_clave" element={<AuthenticatedLayout><CambiarClave /></AuthenticatedLayout>} />
            <Route path="/datos" element={<AuthenticatedLayout><ShowDatos /></AuthenticatedLayout>} />
            <Route path="/formulario/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','promotor','facilitador','asist-centro','servicio-com','servicio-corp','creador-cursos']}><AuthenticatedLayout><CreateDatos /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/datos/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos']}><AuthenticatedLayout><EditDatos/></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/datos/:id" element={<AuthenticatedLayout><ShowMoreDatos /></AuthenticatedLayout>} />
            <Route path="/datos-confirm/:datosId/:id" element={<AuthenticatedLayout><ConfirmDatos /></AuthenticatedLayout>} />
            <Route path="/inscribir/:cursoId" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','promotor','facilitador','asist-centro','servicio-com','servicio-corp','creador-cursos']}><AuthenticatedLayout><InscripcionCursos /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/inscribir/externo/:cursoId" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><InscribirExterno /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/inscribir-cursos/:cedula" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro',,'promotor','facilitador','servicio-com','servicio-corp','creador-cursos']}><AuthenticatedLayout><InscribirCedula /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/inscritos/:cursoId" element={<AuthenticatedLayout><ShowInscritos /></AuthenticatedLayout>} />
             <Route path="/inscritos-aliados/:cursoId" element={<AuthenticatedLayout><ShowInscritosAliados /></AuthenticatedLayout>} />
            <Route path="/inscritosExternos/:cursoId" element={<AuthenticatedLayout><ShowInscritosExternos /></AuthenticatedLayout>} />

            <Route path="/inscritos/show/:id" element={<AuthenticatedLayout><ShowMoreInscripciones /></AuthenticatedLayout>} />
            <Route path="/inscritos/edit/:inscripcionId/:cedula" element={<AuthenticatedLayout><EditInscripciones /></AuthenticatedLayout>} />
            
            <Route path="/inscripcion-confirm/:inscripcionId/:id"element={<AuthenticatedLayout><ConfirmInscripciones /></AuthenticatedLayout>}  />
            <Route path="/inscripcion-datos-confirm/:inscripcionId/:id"element={<AuthenticatedLayout><ConfirmPartEInsc /></AuthenticatedLayout>}  />

            <Route path="/inscripcion-masiva/:cursoId" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos']}><AuthenticatedLayout><InscribirMasivoInterno /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/inscripcion-aliados/:cursoId" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos']}><AuthenticatedLayout><InscribirMasivoAliados /></AuthenticatedLayout></ProtectedRoute>}  />

            <Route path="/indicadores" element={<AuthenticatedLayout><ShowIndicadores /></AuthenticatedLayout>} />
            {/* Punto 13 de José (24/09): mismos roles que ven Indicadores en el menú. */}
            <Route path="/indicadores-iniciativas" element={<ProtectedRoute allowedRoles={['admin','coordinador','creador-cursos','asist-centro','asist-promotor']}><AuthenticatedLayout><ShowIndicadoresIniciativas /></AuthenticatedLayout></ProtectedRoute>} />
            {/* Punto 14 de José (24/09): mismos roles que ven Indicadores en el menú. */}
            <Route path="/red-egresados" element={<ProtectedRoute allowedRoles={['admin','coordinador','creador-cursos','asist-centro','asist-promotor']}><AuthenticatedLayout><ShowRedEgresados /></AuthenticatedLayout></ProtectedRoute>} />
            {/* Seguimiento de Egresados (punto 7 de José, 25/09/2026). Mismos roles que la API. */}
            <Route path="/seguimiento-egresados" element={<ProtectedRoute modulo="seguimiento-egresados"><AuthenticatedLayout><ShowSeguimientoEgresados /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/seguimiento-egresados/:id" element={<ProtectedRoute modulo="seguimiento-egresados"><AuthenticatedLayout><SeguimientoEgresado soloLectura /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/seguimiento-egresados/:id/edit" element={<ProtectedRoute modulo="seguimiento-egresados"><AuthenticatedLayout><SeguimientoEgresado /></AuthenticatedLayout></ProtectedRoute>} />


            <Route path="/cursos" element={<AuthenticatedLayout><ShowCursos /></AuthenticatedLayout>} />
            <Route path="/cursos/externos" element={<AuthenticatedLayout><ShowCursosExternos /></AuthenticatedLayout>} />
            <Route path="/aliados" element={<AuthenticatedLayout><ShowCursosAliados /></AuthenticatedLayout>} />

            <Route path="/cursos/create" element={<ProtectedRoute allowedRoles={['admin','creador-cursos']}><AuthenticatedLayout><CreateCursos /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/cursos/create/externo" element={<ProtectedRoute allowedRoles={['admin','creador-cursos','corporativo']}><AuthenticatedLayout><CreateCursosExterno /></AuthenticatedLayout></ProtectedRoute>}  />

            <Route path="/cursos/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro','creador-cursos','corporativo']}><AuthenticatedLayout><EditCursos /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/cursos/:id/pagos" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro']}><AuthenticatedLayout><CreatePagoCursos /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/cursos/:id" element={<AuthenticatedLayout><ShowMoreCursos /></AuthenticatedLayout>}  />
            <Route path="/curso-confirm/:datosId/:id"element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos']}><AuthenticatedLayout><ConfirmCursos /></AuthenticatedLayout></ProtectedRoute>}  />


            <Route path="/costo-curso/:id" element={<AuthenticatedLayout><ShowCostoCurso /></AuthenticatedLayout>}  />
             <Route path="/costo-curso/:id/create"element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro','creador-cursos','corporativo','promotor']}><AuthenticatedLayout><CreateCostoCurso /></AuthenticatedLayout></ProtectedRoute>}  />
              <Route path="/costo-curso/:id/edit"element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro','creador-cursos','corporativo','promotor']}><AuthenticatedLayout><EditCostoCurso /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/costo-curso-confirm/:id/:peticionId" element={<AuthenticatedLayout><ConfirmCostoCurso /></AuthenticatedLayout>} />



            <Route path="datos/cursos/:cedula_identidad" element={<AuthenticatedLayout><ShowDatosCursos /></AuthenticatedLayout>}  />
            <Route path="/pagos" element={<AuthenticatedLayout><ShowPagos /></AuthenticatedLayout>} />
            <Route path="/pagos/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro']}><AuthenticatedLayout><CreatePagos /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/pagos/:cedula/:cursoId" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','asist-centro']}><AuthenticatedLayout><CreatePagosCedula /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/pagos/:id" element={<AuthenticatedLayout><ShowMorePagos /></AuthenticatedLayout>} />
            <Route path="/pagos/curso/:inscripcion_curso_id" element={<AuthenticatedLayout><ShowPagosCursos /></AuthenticatedLayout>} />
            <Route path="/pagos/programa/:curso_id" element={<AuthenticatedLayout><ShowPagosProgramas /></AuthenticatedLayout>} />
            
            
            <Route path="/voluntariados" element={<AuthenticatedLayout><ShowVoluntariados /></AuthenticatedLayout>} />
            <Route path="/voluntariados/:id" element={<AuthenticatedLayout><ShowMoreVoluntariados /></AuthenticatedLayout>} />
            <Route path="/voluntariados/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos','asist-centro']}><AuthenticatedLayout><CreateVoluntariados /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/voluntariados/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'coordinador']}><AuthenticatedLayout><EditVoluntariados /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/voluntariados-confirm/:id/:peticionId" element={<AuthenticatedLayout><ConfirmVoluntariados /></AuthenticatedLayout>} />

            
            
            
            {/* Beneficiarios sin datos (antes Promoción): solo admin y coordinador, también para ver. */}
            <Route path="/promocion" element={<ProtectedRoute modulo="beneficiarios"><AuthenticatedLayout><ShowPromocion /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/promocion/:id" element={<ProtectedRoute modulo="beneficiarios"><AuthenticatedLayout><ShowMorePromocion /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/promocion/create" element={<ProtectedRoute modulo="beneficiarios"><AuthenticatedLayout><CreatePromocion /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/promocion/:id/edit" element={<ProtectedRoute modulo="beneficiarios"><AuthenticatedLayout><EditPromocion /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/patrocinantes" element={<AuthenticatedLayout><ShowPatrocinantes /></AuthenticatedLayout>} />
            <Route path="/patrocinantes/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo','creador-cursos']}><AuthenticatedLayout><CreatePatrocinantes /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/patrocinantes/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo','creador-cursos']}><AuthenticatedLayout><EditPatrocinantes /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/patrocinantes/:id" element={<AuthenticatedLayout><ShowMorePatrocinantes /></AuthenticatedLayout>}  />
            <Route path="/procedencias" element={<AuthenticatedLayout><ShowProcedencias /></AuthenticatedLayout>} />
            <Route path="/procedencias/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos','asist-centro']}><AuthenticatedLayout><CreateProcedencias /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/procedencias/edit/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos','asist-centro']}><AuthenticatedLayout><EditProcedencias /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/procedencia-confirm/:id/:peticionId" element={<AuthenticatedLayout><ConfirmProcedencia /></AuthenticatedLayout>} />

             <Route path="/centros" element={<AuthenticatedLayout><ShowCentros /></AuthenticatedLayout>} />
             <Route path="/centros/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador']}><AuthenticatedLayout><CreateCentros /></AuthenticatedLayout></ProtectedRoute>}  />
             <Route path="/centros/edit/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador']}><AuthenticatedLayout><EditCentros /></AuthenticatedLayout></ProtectedRoute>}  />  
             <Route path="/centro-confirm/:id/:peticionId" element={<AuthenticatedLayout><ConfirmCentro /></AuthenticatedLayout>} />


              <Route path="/iniciativas" element={<AuthenticatedLayout><ShowIniciativas /></AuthenticatedLayout>} />
             <Route path="/iniciativas/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','coorporativo']}><AuthenticatedLayout><CreateIniciativas /></AuthenticatedLayout></ProtectedRoute>}  />
             <Route path="/iniciativas/edit/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','coorporativo']}><AuthenticatedLayout><EditIniciativas /></AuthenticatedLayout></ProtectedRoute>}  />  
            <Route path="/insc-iniciativas" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><ShowInscIniciativas /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/insc-iniciativas/:id" element={<AuthenticatedLayout><ShowInscritosIniciativas /></AuthenticatedLayout>} />
            <Route path="/insc-iniciativas/edit/:inscripcionId/:cedula" element={<AuthenticatedLayout><EditInscIniciativas /></AuthenticatedLayout>} />
            <Route path="/insc-iniciativas-insc/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','creador-cursos']}><AuthenticatedLayout><InscribirIniciativas /></AuthenticatedLayout></ProtectedRoute>}  />


            <Route path="/part-iniciativas" element={<AuthenticatedLayout><ShowPartIniciativas /></AuthenticatedLayout>} />
            <Route path="/part-iniciativas/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><CreatePartIniciativa /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/part-iniciativas/:id" element={<AuthenticatedLayout><ShowMorePartIniciativa /></AuthenticatedLayout>} />
              <Route path="/part-iniciativas/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><CreatePartIniciativa /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/part-iniciativas/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><EditPartIniciativa /></AuthenticatedLayout></ProtectedRoute>} />

            <Route path="/cohorte" element={<AuthenticatedLayout><ShowCohorte /></AuthenticatedLayout>} />
             <Route path="/cohorte/create" element={<ProtectedRoute allowedRoles={['admin', 'coordinador']}><AuthenticatedLayout><CreateCohorte /></AuthenticatedLayout></ProtectedRoute>}  />
             <Route path="/cohorte/edit/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador']}><AuthenticatedLayout><EditCohorte /></AuthenticatedLayout></ProtectedRoute>}  />  


            <Route path="/bolsa-empleo" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><ShowBolsaEmpleo /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/postulaciones/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><ShowPostulaciones /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/postulaciones-empresas/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><ShowPostulacionesEmpresas /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/inscribir-part-bolsa" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><IncsParticipanteBolsa /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/edit-part-bolsa/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><EditIncsParticipanteBolsa /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/bolsa-empleo/:patrocinanteId" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><IncsEmpleo /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/postulados-bolsa-empleo" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><ShowPostulados /></AuthenticatedLayout></ProtectedRoute>}  />
            <Route path="/postulados-bolsa-empleo/:id" element={<ProtectedRoute allowedRoles={['admin', 'coordinador','corporativo']}><AuthenticatedLayout><ShowMorePostulados /></AuthenticatedLayout></ProtectedRoute>}  />


          </Routes>
        </Router>
      
    </LoadingProvider>
  );
}

const AuthenticatedLayout = ({ children }) => {
  const location = useLocation(); // Obtén la ubicación actual
  const [pageTitle, setPageTitle] = useState('');

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const userRole = localStorage.getItem('role');
    const userName = localStorage.getItem('username');
  const [showModal, setShowModal] = useState(false);
  const INACTIVITY_LIMIT = 10 * 60 * 1000; // el primer valor representa los min
  const COUNTDOWN_LIMIT = 15; // 15 segundos
  
  const [countdown, setCountdown] = useState(COUNTDOWN_LIMIT);
  const [modalActive, setModalActive] = useState(false);

  const timerRef = useRef(null);
  const countdownRef = useRef(null);
    const [showAccessDeniedModal, setShowAccessDeniedModal] = useState(false);
  const [accessDeniedMessage, setAccessDeniedMessage] = useState('');

   useEffect(() => {
    // Interceptor global de errores
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 403 && error.response?.data?.message) {
          setAccessDeniedMessage(error.response.data.message);
          setShowAccessDeniedModal(true);
        }
        return Promise.reject(error);
      }
    );

    // Limpiar interceptor al desmontar
    return () => axios.interceptors.response.eject(interceptor);
  }, []);


  const fetchUser = async () => {
    try {
      const storedUser = sessionStorage.getItem('user'); // Verifica si el usuario ya está almacenado en sessionStorage
      if (storedUser) {
        setUser(JSON.parse(storedUser)); // Si ya hay datos guardados, los usa
      } else {
        const token = localStorage.getItem('token'); // Sigue usando localStorage para el token
        if (!token) {
          throw new Error("No token found");
        }
  
        const response = await axios.get('/user', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        setUser(response.data);
        sessionStorage.setItem('user', JSON.stringify(response.data)); // Almacena los datos del usuario en sessionStorage
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      navigate('/'); // Redirige al login si falla
    }
  };


   //console.log("mi rol es :", userRole);
  

  const dropdownRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('0px');

 
  useEffect(() => {
    if (openDropdown && dropdownRef.current) {
      setMaxHeight(`${dropdownRef.current.scrollHeight}px`);
    } else {
      setMaxHeight('0px');
    }
  }, [openDropdown]);


  useEffect(() => {

    fetchUser();
    // scheduleTasaUpdate();
  }, [navigate]);
  const handleLogout = async () => {
    try {
      clearInterval(countdownRef.current);
      const token = localStorage.getItem('token');

      await axios.post('/logout', {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      localStorage.removeItem('token');
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  

  const toggleDropdowns = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };



  const resetTimer = () => {
    if (modalActive) return; // no reiniciar cuando modal esté activo
    clearTimeout(timerRef.current);
    setCountdown(COUNTDOWN_LIMIT);
    timerRef.current = setTimeout(handleInactivity, INACTIVITY_LIMIT);
  };

  const handleInactivity = () => {
    setShowModal(true);
    setModalActive(true);
    setCountdown(COUNTDOWN_LIMIT); // Reiniciar contador
    countdownRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          handleLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };



  const continueSession = () => {
    clearInterval(countdownRef.current);
    setShowModal(false);
    setModalActive(false);
    resetTimer();
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
      clearInterval(countdownRef.current);
    };

  }, [modalActive]);

  return (
    <div className="app-container">
   {/* Sidebar */}
  <div className={`sidebar`}>
    <div className="logo">
      <img src="/IMG/Simedimos_Logo_var3.png" alt="Logo" />
    </div>
    <ul>
       {userRole === 'admin' ||  userRole === 'creador-cursos' || userRole === 'coordinador' 
       || userRole === 'promotor' || userRole === 'facilitador' || userRole === 'servicio-com'  
       || userRole === 'servicio-corp' || userRole === 'asist-centro'? (
      <li className={openDropdown === 1 ? 'expanded' : ''}>
        <div className="dropdown-button" onClick={() => toggleDropdown(1)}>
          <i className="bi bi-highlighter"></i> Inscripciones
          <i className={`bi ${openDropdown === 1 ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
        </div>
        <ul className={`dropdown-menu ${openDropdown === 1 ? 'show' : ''}`}>
          {userRole === 'admin' ||  userRole === 'coordinador' || userRole === 'promotor' 
          || userRole === 'facilitador' || userRole === 'servicio-com' 
           || userRole === 'servicio-corp' || userRole === 'asist-centro' || userRole === 'creador-cursos' ||   userRole === 'empleabilidad' ? (
          <li><NavLink to="/datos"><i className="bi bi-person-circle"></i> Participantes</NavLink></li>
          ) : null}
          {puedeVerModulo('seguimiento-egresados') ? (
          <li><NavLink to="/seguimiento-egresados"><i className="bi bi-person-check-fill"></i> Seguimiento Egresados</NavLink></li>
          ) : null}
          {userRole === 'admin' || userRole === 'creador-cursos' || userRole === 'coordinador'
           || userRole === 'promotor' || userRole === 'facilitador' || userRole === 'servicio-com'  
           || userRole === 'servicio-corp' || userRole === 'asist-centro' ||   userRole === 'empleabilidad'? (
             <li><NavLink to="/cursos"><i className="bi bi-book-half"></i> Unidad Curricular</NavLink></li>
              ) : null}
             {userRole === 'admin' ||  userRole === 'coordinador' || userRole === 'asist-centro' ? (
          <li><NavLink to="/pagos"><i className="bi bi-credit-card-fill"></i> Reporte de Pagos</NavLink></li>
           ) : null}
          
           {puedeVerModulo('beneficiarios') ? (
          <li><NavLink to="/promocion"><i className="bi bi-star-fill"></i> Beneficiarios sin datos</NavLink></li>
           ) : null}
            {userRole === 'admin' ||  userRole === 'coordinador'  ||  userRole === 'creador-cursos' ||  userRole === 'asist-centro' ||  userRole === 'asist-promotor'  ? (
          <>
          <li><NavLink to="/indicadores"><i className="bi bi-sliders"></i> Indicadores</NavLink></li>
          <li><NavLink to="/indicadores-iniciativas"><i className="bi bi-bar-chart-fill"></i> Indicadores Iniciativas</NavLink></li>
          <li><NavLink to="/red-egresados"><i className="bi bi-mortarboard-fill"></i> Red de Egresados</NavLink></li>
          </>
           ) : null}
        </ul>
      </li>
       ) : null}
        {userRole === 'admin' ||  userRole === 'creador-cursos'||   userRole === 'coordinador'  ||   userRole === 'asist-centro' ?  (
      <li className={openDropdown === 2 ? 'expanded' : ''}>
        <div className="dropdown-button " onClick={() => toggleDropdown(2)}>
          <i className="bi bi-globe2"></i> Aliados
          <i className={`bi ${openDropdown === 2 ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>  
        </div>
        <ul className={`dropdown-menu ${openDropdown === 2 ? 'show' : ''}`}>
          {userRole === 'admin'||  userRole === 'creador-cursos' ||   userRole === 'coordinador' ||   userRole === 'asist-centro' ? (
          <li><NavLink to="/aliados"><i className="bi bi-book-half"></i>U.C Aliadas</NavLink></li>
           ) : null}

        </ul>
      </li>
      ) : null}
      {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'creador-cursos' 
      ||   userRole === 'corporativo' ||   userRole === 'servicio-corp'  ||   userRole === 'empleabilidad'  ? (
      <li className={openDropdown === 3 ? 'expanded' : ''}>
        <div className="dropdown-button " onClick={() => toggleDropdown(3)}>
          <i className="bi bi-person-workspace"></i> Corporativo
          <i className={`bi ${openDropdown === 3 ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
        </div>
        <ul className={`dropdown-menu ${openDropdown === 3 ? 'show' : ''}`}>
          {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'corporativo' ||   userRole === 'empleabilidad' ? (
          <li><NavLink to="/bolsa-empleo"><i className="bi bi-building"></i> Empresas</NavLink></li>
           ) : null}
            {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'corporativo' ||   userRole === 'empleabilidad'? (
          <li><NavLink to="/postulados-bolsa-empleo"><i className="bi bi-person"></i> Postulados</NavLink></li>
          ) : null}
          {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'creador-cursos' ||   userRole === 'corporativo'
           ||   userRole === 'corporativo' ||   userRole === 'servicio-corp' ||   userRole === 'empleabilidad' ? (
          <li><NavLink to="/cursos/externos"><i className="bi bi-book-half"></i> U.C Externa</NavLink></li>
            ) : null}

            {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'corporativo' ||   userRole === 'empleabilidad'? (
          <li><NavLink to="/insc-iniciativas"><i className="bi bi-journal-plus"></i> Insc Iniciaivas</NavLink></li>
           ) : null}

            {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'corporativo'||   userRole === 'empleabilidad' ? (
          <li><NavLink to="/part-iniciativas"><i className="bi bi-person-fill-add"></i> Part Iniciativas</NavLink></li>
           ) : null}

        </ul>
      </li>
      ) : null}
        

        {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'creador-cursos'  ||   userRole === 'asist-centro' ? (
      <li className={openDropdown === 5 ? 'expanded' : ''}>
        <div className="dropdown-button " onClick={() => toggleDropdown(5)}>
          <i className="bi bi-person-rolodex"></i> Voluntariados
          <i className={`bi ${openDropdown === 5 ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>  
        </div>
        <ul className={`dropdown-menu ${openDropdown === 5 ? 'show' : ''}`}>
          {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'creador-cursos' ||   userRole === 'asist-centro' ? (
          <li><NavLink to="/voluntariados"><i className="bi bi-person-raised-hand"></i> Lista de Voluntariados</NavLink></li>
           ) : null}

        </ul>
      </li>
      ) : null}


       {userRole === 'admin' ||   userRole === 'coordinador' ||   userRole === 'empleabilidad' ||   userRole === 'asist-centro' ||   userRole === 'creador-cursos' ? (
       <li className={openDropdown === 4 ? 'expanded' : ''}>
        <div className="dropdown-button " onClick={() => toggleDropdown(4)}>
          <i className="bi bi-key-fill"></i> Maestros
          <i className={`bi ${openDropdown === 3 ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
        </div>
        
        <ul className={`dropdown-menu ${openDropdown === 4 ? 'show' : ''}`}>
           {userRole === 'admin' ||  userRole === 'coordinador' ||  userRole === 'corporativo' ||   userRole === 'empleabilidad' ||   userRole === 'creador-cursos'  ? (
          <li><NavLink to="/patrocinantes"><i className="bi bi-building"></i> Patrocinantes</NavLink></li>
          ) : null}
        {userRole === 'admin' ||   userRole === 'coordinador'  ||   userRole === 'asist-centro' ||   userRole === 'creador-cursos'  ? (
          <li><NavLink to="/procedencias"><i className="bi bi-geo-fill"></i> Procedencias</NavLink></li>
          ) : null}
          {userRole === 'admin' ||   userRole === '' ? (
          <li><NavLink to="/centros"><i className="bi bi-buildings"></i> Centros</NavLink></li>
          ) : null}
          {userRole === 'admin' ||   userRole === '' ? (
          <li><NavLink to="/cohorte"><i className="bi bi-calendar-event"></i> Cohorte</NavLink></li>
            ) : null}

            {userRole === 'admin' ||   userRole === 'coordinador'  ||   userRole === 'corporativo' 
           ||   userRole === 'corporativo' ||   userRole === 'servicio-corp'  ? (
          <li><NavLink to="/iniciativas"><i className="bi bi-pass-fill"></i> Iniciativas</NavLink></li>
            ) : null}
        </ul>
      </li>
       ) : null}
    </ul>
  </div>


      <div className="header">

      
        <div className="header-content">
        
          <div className="user-section ">
            {/* Íconos a la izquierda */}
            <div className="icon-container">
              <div className="user-icon" onClick={() => navigate('/peticiones')} title='Bandeja de Entrada'>
                <i className="bi bi-inbox-fill" style={{ fontSize: '1.6rem', cursor: 'pointer', }}></i>
              </div>
              {userRole === 'admin' && (
                <div className="user-icon" onClick={() => navigate('/users')} title='Administrar Usuarios'>
                  <i className="bi bi-person-fill-gear" style={{ fontSize: '1.5rem', cursor: 'pointer', }}></i>
                </div>
              )}
            </div>

            {/* Nombre de Rol y Círculo */}
            <span className="user-role  ">{userRole}</span>
            <div className="user-circle" onClick={toggleDropdowns} title='Ver Opciones'>
              <span className="user-initial">{user?.username?.charAt(0).toUpperCase()}</span>
            </div>

            {/* Menú Desplegable de Logout */}
            {isDropdownOpen && (
            <div className="dropdown-menux">
              <div className="logout-options " >
              <span >Usuario: {userName}</span>
              </div>
              <div className="logout-option" onClick={() => navigate('/cambiar_clave')}>
              <i className="bi bi-lock" style={{ marginRight: '8px' }}></i>
              <span>Cambiar Clave</span>
              </div>
              <div className="logout-option" onClick={() => navigate('/f2a/config')}>
              <i className="bi bi-shield-check" style={{ marginRight: '8px' }}></i>
              <span>Doble verificaciòn</span>
              </div>
              <div className="logout-option" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right" style={{ marginRight: '8px' }}></i>
                <span>Logout</span>
              </div>
            </div>
          )}

<Modal show={showModal} centered backdrop="static" size="md">
        <Modal.Header>
          <Modal.Title style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>Inactividad Detectada</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>
          <p>Tu sesión se cerrará por inactividad en:</p>
          <h1 style={{ fontSize: '3rem', color: '#9b9b9b', fontWeight: 'bold' }}>{countdown}s</h1>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          {/* <Button variant="danger" onClick={handleLogout}>Cerrar Sesión Ahora</Button> */}
          <Button variant="info" onClick={continueSession}>Continuar Sesión</Button>
        </Modal.Footer>
      </Modal>

     {/* Modal de acceso denegado */}
      <Modal show={showAccessDeniedModal} onHide={() => {
        setShowAccessDeniedModal(false);
        navigate(-1); // Redirige a la ruta anterior
      }}>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            <BsExclamationCircleFill color="red" size={22} />
            Acceso denegado
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {accessDeniedMessage || 'No tienes permisos para acceder a esta sección.'}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowAccessDeniedModal(false);
            navigate('/peticiones'); // Redirige a la ruta anterior
          }}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

          </div>
        </div>
      </div>

      {/* Main content */}
      <div className={`content `}>
      <LoadingOverlay>
        {children} {/* Aquí va el contenido principal */}
        </LoadingOverlay>
      </div>
    </div>
  );
};

const LoadingOverlay = ({ children }) => {
  const { loading } = useLoading();

  return (
    <>
      {loading && <Loader /> }
      {children}
    </>
  );
};

export default App;
